import { createStore } from "vuex";

const store = createStore({
  state () {
    return {
      xToken: 'Bearer ' + (localStorage.getItem("xToken") || ''),
      BookingStep: 1,
      isAuth: false,
      routeData: {},
      isUserSalesAdminRole: false
    }
  },
  mutations: {
    setToken (state, xToken) {
      state.xToken = 'Bearer ' + xToken
    },
    setBookingStep (state, step) {
      if (step === undefined) {
        state.BookingStep += 1
      } else {
        state.BookingStep = step
      }
    },
    setIsAuth (state, isAuth) {
      state.isAuth = isAuth
    },
    setRouteData (state, routeData) {
      state.routeData = routeData
    },
    setUserSalesAdminRole (state, isUserSalesAdminRole) {
      state.isUserSalesAdminRole = isUserSalesAdminRole
    }
  },
  getters: {

    LoginNickName () {
      return "测试用户"
    },
    BookingStep (state) {
      return state.BookingStep
    },
    routeData (state) {
      return state.routeData
    },
    isUserSalesAdminRole: async (state) => {
      return state.isUserSalesAdminRole
    }
  }
})


export default store
